"use strict";

var _interopRequireDefault = require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
var _constant = require("../constant");
var _emit = _interopRequireDefault(require("../emit"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  name: 'SFCAddNode',
  props: {
    nodeList: {
      type: [Array, null],
      default: function _default() {
        return null;
      }
    },
    nodeData: {
      type: Object,
      default: null
    },
    btnType: {
      type: String,
      default: '' // dot、normal
    }
  },
  data: function data() {
    return {
      readonly: _constant.store.readonly,
      vertical: _constant.store.vertical,
      addNodeBtnType: '',
      showNodeTypePopover: false,
      nodeTypePopoverStyle: {}
    };
  },
  computed: {
    type: function type() {
      return this.addNodeBtnType === 'normal' ? this.addNodeBtnType : this.btnType || this.addNodeBtnType;
    }
  },
  watch: {
    showNodeTypePopover: function showNodeTypePopover(val) {
      var _this = this;
      if (val) {
        this.$nextTick(function () {
          _this.setNodeTypePopoverStyle();
        });
      } else {
        setTimeout(function () {
          _this.resetNodeTypePopoverStyle();
        }, 300);
      }
    }
  },
  created: function created() {
    this.resetNodeTypePopoverStyle();
  },
  methods: {
    setNodeTypePopoverStyle: function setNodeTypePopoverStyle() {
      var el = this.$refs.nodeTypePopover;
      if (!el) {
        return;
      }
      var elWidth = el.offsetWidth;
      var elHeight = el.offsetHeight;
      var _el$getBoundingClient = el.getBoundingClientRect(),
        left = _el$getBoundingClient.left,
        top = _el$getBoundingClient.top;
      var windowWidth = window.innerWidth;
      var windowHeight = window.innerHeight;
      var style = {};
      style[top + elHeight > windowHeight ? 'bottom' : 'top'] = 0;
      style[left + elWidth > windowWidth ? 'right' : 'left'] = 42 + 'px';
      this.nodeTypePopoverStyle = style;
    },
    resetNodeTypePopoverStyle: function resetNodeTypePopoverStyle() {
      this.nodeTypePopoverStyle = {
        left: '42px',
        top: 0
      };
    },
    onMouseenter: function onMouseenter() {
      this.addNodeBtnType = 'normal';
    },
    onMouseleave: function onMouseleave() {
      this.addNodeBtnType = '';
    },
    onAddBtnMouseenter: function onAddBtnMouseenter() {
      this.showNodeTypePopover = true;
    },
    onAddBtnMouseleave: function onAddBtnMouseleave() {
      this.showNodeTypePopover = false;
    },
    onNodeTypeClick: function onNodeTypeClick() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _emit.default.emit.apply(_emit.default, ['add-node-type-click', this.nodeList, this.nodeData].concat(args));
      this.showNodeTypePopover = false;
    }
  }
};